import { IMSId, IMSObject } from './ims-object';

export interface TagTemplateElementDTO {
  id: number;
  secondaryid: number;
  label: string;
  parent: {
    id: number;
    label: string;
  };
  tagtemplate: {
    id: number;
    label: string;
  };
}

export class TagTemplateElement extends IMSObject {
  static fromDto(dto: TagTemplateElementDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/TagTemplateElement',
      },
      dto.label,
      dto.parent ? new IMSObject(dto.parent.id, undefined, dto.parent.label, 'ims/TagTemplateElement') : undefined,
      dto.tagtemplate ? new IMSObject(dto.tagtemplate.id, undefined, dto.tagtemplate.label, 'ims/TagTemplate') : undefined
    );
    obj.databag = databag ? databag : dto;
    return obj;
  }

  public get name(): string {
    return this.databag.name;
  }
  public set name(value: string) {
    this.databag.name = value;
  }

  public get required(): boolean {
    return this.databag.required;
  }
  public set required(value: boolean) {
    this.databag.required = value;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public parent: IMSObject,
    public tagtemplate: IMSObject
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/TagTemplateElement');
  }
}
